import React from 'react';

function Croatia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124105)">
        <mask
          id="mask0_800_124105"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124105)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124105"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124105)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#3D58DB"
            />
            <rect
              x="11.3362"
              y="6.39734"
              width="12.825"
              height="4"
              fill="#E31D1C"
            />
            <path
              d="M11.9134 8.95984H23.4486C23.4678 9.72613 23.4737 11.0674 23.4736 12.3615C23.4735 13.1953 23.471 13.9981 23.4686 14.5925C23.4673 14.8896 23.4661 15.1347 23.4652 15.3054L23.4641 15.5029L23.4639 15.5259C23.4591 15.5519 23.4509 15.5921 23.4385 15.6448C23.413 15.7531 23.3699 15.913 23.3011 16.1071C23.1632 16.4964 22.9251 17.0157 22.5261 17.5335C21.7448 18.5475 20.3035 19.6153 17.606 19.6153C14.9103 19.6153 13.5384 18.5476 12.8208 17.5446C12.4527 17.0302 12.2436 16.5135 12.1271 16.125C12.069 15.9315 12.0346 15.772 12.015 15.6639C12.0052 15.6099 11.9991 15.569 11.9957 15.5433C11.9951 15.5385 11.9945 15.5343 11.9941 15.5306L11.9935 15.4893L11.9908 15.293L11.9813 14.5845C11.9734 13.9936 11.9628 13.195 11.9523 12.364C11.9362 11.0941 11.9201 9.75305 11.9134 8.95984Z"
              fill="#F7FCFF"
              stroke="#E31D1C"
              strokeWidth="1.125"
            />
            <mask
              id="mask2_800_124105"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="11"
              y="8"
              width="14"
              height="13"
            >
              <path
                d="M11.9134 8.95984H23.4486C23.4678 9.72613 23.4737 11.0674 23.4736 12.3615C23.4735 13.1953 23.471 13.9981 23.4686 14.5925C23.4673 14.8896 23.4661 15.1347 23.4652 15.3054L23.4641 15.5029L23.4639 15.5259C23.4591 15.5519 23.4509 15.5921 23.4385 15.6448C23.413 15.7531 23.3699 15.913 23.3011 16.1071C23.1632 16.4964 22.9251 17.0157 22.5261 17.5335C21.7448 18.5475 20.3035 19.6153 17.606 19.6153C14.9103 19.6153 13.5384 18.5476 12.8208 17.5446C12.4527 17.0302 12.2436 16.5135 12.1271 16.125C12.069 15.9315 12.0346 15.772 12.015 15.6639C12.0052 15.6099 11.9991 15.569 11.9957 15.5433C11.9951 15.5385 11.9945 15.5343 11.9941 15.5306L11.9935 15.4893L11.9908 15.293L11.9813 14.5845C11.9734 13.9936 11.9628 13.195 11.9523 12.364C11.9362 11.0941 11.9201 9.75305 11.9134 8.95984Z"
                fill="white"
                stroke="white"
                strokeWidth="1.125"
              />
            </mask>
            <g mask="url(#mask2_800_124105)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.8108 9.03992H14.1838V11.1818H11.8108V9.03992ZM14.1839 11.1818H16.5569V13.3237H18.93V11.1818H21.303V13.3237H23.6761V15.4656H21.303V13.3237H18.93V15.4656H16.5569V13.3237H14.1839V11.1818ZM16.5569 15.4656H14.1839V17.6075H16.5569V19.7494H18.93V17.6075H21.303V19.7494H23.6761V17.6075H21.303V15.4656H18.93V17.6075H16.5569V15.4656ZM11.8108 13.3237H14.1838V15.4656H11.8108V13.3237ZM18.93 9.03992H16.5569V11.1818H18.93V9.03992ZM21.303 9.03992H23.6761V11.1818H21.303V9.03992ZM14.1838 17.6075H11.8108V19.7494H14.1838V17.6075Z"
                fill="#F50100"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.7597 8.16264C11.7597 8.16264 12.4937 7.81414 13.1198 7.63455C13.7458 7.45495 14.2406 7.35682 14.2406 7.35682L13.3092 4.30473L11.4436 3.68515L10.387 5.23325L11.7597 8.16264Z"
              fill="#56C6F5"
              stroke="white"
              strokeWidth="0.5"
            />
            <path
              d="M11.4539 6.49079L11.6682 6.39893C11.8896 6.81985 12.1814 6.94986 12.5814 6.81718C12.99 6.68164 13.1565 6.42535 13.0978 6.01903L13.3331 5.9913C13.406 6.49567 13.1772 6.84772 12.6633 7.01822C12.1407 7.19156 11.725 7.00635 11.4539 6.49079Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.9615 5.54186L11.7417 5.66021C11.7008 5.68226 11.6536 5.64709 11.6636 5.602L11.7117 5.38637L11.5037 5.28474C11.4597 5.26326 11.4661 5.19866 11.5136 5.18429L11.7383 5.11632L11.7331 4.89654C11.732 4.85059 11.7853 4.82324 11.8213 4.85127L12.0147 5.00175L12.2345 4.8834C12.2754 4.86135 12.3226 4.89652 12.3126 4.94161L12.2645 5.15724L12.4725 5.25887C12.5165 5.28035 12.5101 5.34495 12.4626 5.35931L12.2379 5.42729L12.2431 5.64706C12.2442 5.69302 12.1909 5.72037 12.1549 5.69233L11.9615 5.54186Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.3584 7.07581C16.3584 7.07581 16.9844 7.02616 17.6421 7.03752C18.2998 7.04887 18.8562 7.05303 18.8562 7.05303L19.1775 4.04355L17.7686 2.91216L16.2025 4.07014L16.3584 7.07581Z"
              fill="#56C6F5"
              stroke="white"
              strokeWidth="0.5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.7191 6.58484C18.2617 6.58484 18.3137 6.06388 18.3137 5.709C18.1749 5.51216 18.2029 5.37131 17.7581 5.37131C17.3134 5.37131 17.2626 5.49077 17.1328 5.709C17.1328 6.06388 17.1764 6.58484 17.7191 6.58484Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.3299 5.11289C18.8725 5.11289 18.9245 4.59192 18.9245 4.23704C18.7858 4.04021 18.8137 3.89935 18.3689 3.89935C17.9242 3.89935 17.8734 4.01882 17.7437 4.23704C17.7437 4.59192 17.7873 5.11289 18.3299 5.11289Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.1434 5.11289C17.686 5.11289 17.738 4.59192 17.738 4.23704C17.5992 4.04021 17.6272 3.89935 17.1824 3.89935C16.7377 3.89935 16.6869 4.01882 16.5571 4.23704C16.5571 4.59192 16.6007 5.11289 17.1434 5.11289Z"
              fill="#FECA00"
            />
            <path
              d="M13.9517 7.3682L14.0267 7.59492L14.2567 7.53027L14.2567 7.53027L14.2567 7.53027L14.2567 7.53025L14.257 7.53017L14.2584 7.52978L14.2642 7.52816L14.2873 7.52179C14.3075 7.51625 14.3369 7.50822 14.3738 7.4984C14.4474 7.47874 14.5502 7.45197 14.6662 7.42357C14.9015 7.366 15.1802 7.30455 15.3832 7.27947C15.5938 7.25347 15.8552 7.23454 16.0671 7.22208C16.1724 7.21588 16.2642 7.21136 16.3297 7.20838L16.4063 7.20507L16.4267 7.20426L16.4318 7.20407L16.4331 7.20402L16.4333 7.20401L16.4334 7.20401L16.6988 7.19432L16.6731 6.93002L16.3893 4.00561L16.3775 3.88373L16.2739 3.81836L14.7409 2.85055L14.5789 2.74829L14.438 2.87811L13.0447 4.16202L12.9261 4.27133L12.9768 4.42446L13.9517 7.3682Z"
              fill="#2E42A5"
              stroke="white"
              strokeWidth="0.5"
            />
            <mask
              id="mask3_800_124105"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="12"
              y="2"
              width="5"
              height="6"
            >
              <path
                d="M13.9517 7.3682L14.0267 7.59492L14.2567 7.53027L14.2567 7.53027L14.2567 7.53027L14.2567 7.53025L14.257 7.53017L14.2584 7.52978L14.2642 7.52816L14.2873 7.52179C14.3075 7.51625 14.3369 7.50822 14.3738 7.4984C14.4474 7.47874 14.5502 7.45197 14.6662 7.42357C14.9015 7.366 15.1802 7.30455 15.3832 7.27947C15.5938 7.25347 15.8552 7.23454 16.0671 7.22208C16.1724 7.21588 16.2642 7.21136 16.3297 7.20838L16.4063 7.20507L16.4267 7.20426L16.4318 7.20407L16.4331 7.20402L16.4333 7.20401L16.4334 7.20401L16.6988 7.19432L16.6731 6.93002L16.3893 4.00561L16.3775 3.88373L16.2739 3.81836L14.7409 2.85055L14.5789 2.74829L14.438 2.87811L13.0447 4.16202L12.9261 4.27133L12.9768 4.42446L13.9517 7.3682Z"
                fill="white"
                stroke="white"
                strokeWidth="0.5"
              />
            </mask>
            <g mask="url(#mask3_800_124105)">
              <path
                d="M13.991 6.63787L13.7092 6.04779C14.3145 5.8123 15.3369 5.6678 16.4128 5.6113L16.4542 6.25278C15.454 6.30531 14.5079 6.43679 13.991 6.63787Z"
                fill="#C51918"
              />
              <path
                d="M13.5155 5.21051L13.2336 4.62043C13.8389 4.38493 15.1399 4.19429 16.2158 4.13779L16.2571 4.77927C15.2569 4.8318 14.0323 5.00943 13.5155 5.21051Z"
                fill="#C51918"
              />
            </g>
            <path
              d="M21.384 7.36223L21.3129 7.59656L21.0771 7.53027L21.0771 7.53027L21.0771 7.53027L21.0771 7.53025L21.0768 7.53017L21.0754 7.52978L21.0695 7.52816L21.0465 7.52179C21.0263 7.51625 20.9968 7.50822 20.96 7.4984C20.8863 7.47874 20.7836 7.45197 20.6676 7.42357C20.4323 7.366 20.1536 7.30455 19.9505 7.27947C19.74 7.25347 19.4785 7.23454 19.2667 7.22208C19.1614 7.21588 19.0695 7.21136 19.0041 7.20838L18.9275 7.20507L18.9071 7.20426L18.902 7.20407L18.9007 7.20402L18.9004 7.20401L18.9004 7.20401L18.635 7.19432L18.6607 6.93002L18.9445 4.00561L18.9563 3.88373L19.0599 3.81836L20.5929 2.85055L20.7596 2.74534L20.9008 2.88283L22.2144 4.1619L22.3235 4.26805L22.2793 4.41365L21.384 7.36223Z"
              fill="#2E42A5"
              stroke="white"
              strokeWidth="0.5"
            />
            <mask
              id="mask4_800_124105"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="18"
              y="2"
              width="5"
              height="6"
            >
              <path
                d="M21.384 7.36223L21.3129 7.59656L21.0771 7.53027L21.0771 7.53027L21.0771 7.53027L21.0771 7.53025L21.0768 7.53017L21.0754 7.52978L21.0695 7.52816L21.0465 7.52179C21.0263 7.51625 20.9968 7.50822 20.96 7.4984C20.8863 7.47874 20.7836 7.45197 20.6676 7.42357C20.4323 7.366 20.1536 7.30455 19.9505 7.27947C19.74 7.25347 19.4785 7.23454 19.2667 7.22208C19.1614 7.21588 19.0695 7.21136 19.0041 7.20838L18.9275 7.20507L18.9071 7.20426L18.902 7.20407L18.9007 7.20402L18.9004 7.20401L18.9004 7.20401L18.635 7.19432L18.6607 6.93002L18.9445 4.00561L18.9563 3.88373L19.0599 3.81836L20.5929 2.85055L20.7596 2.74534L20.9008 2.88283L22.2144 4.1619L22.3235 4.26805L22.2793 4.41365L21.384 7.36223Z"
                fill="white"
                stroke="white"
                strokeWidth="0.5"
              />
            </mask>
            <g mask="url(#mask4_800_124105)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.6976 6.46654C20.6976 6.46654 21.0283 6.30291 21.076 6.02703C21.1237 5.75115 21.6352 5.41135 21.3795 5.45179C21.1237 5.49224 21.2699 5.52383 20.8996 5.45179C20.5292 5.37976 20.0498 5.33212 20.0498 5.12973C20.0498 4.92735 20.2881 4.76671 20.0933 4.76671C19.8985 4.76671 19.483 4.57516 19.5664 4.72157C19.6499 4.86798 19.3744 4.70243 19.5122 5.0064C19.6499 5.31036 19.483 5.61658 19.5664 5.69716C19.6499 5.77773 19.5122 6.17292 19.5122 6.17292C19.5122 6.17292 19.5628 6.3197 19.6512 6.09986C19.7397 5.88001 19.9334 5.72591 19.8366 5.91288C19.7397 6.09986 19.6162 6.54458 19.7264 6.46654C19.8366 6.3885 19.9461 6.17268 19.9461 6.09986C19.9461 6.02703 20.2241 5.74117 20.2241 5.95705C20.2241 6.17292 19.9625 6.34293 20.0933 6.34293C20.2241 6.34293 20.2974 6.3888 20.3796 6.17292C20.4618 5.95705 20.6615 5.81424 20.7434 5.95705C20.8253 6.09986 20.8071 6.09223 20.6976 6.27938C20.5881 6.46654 20.6976 6.46654 20.6976 6.46654Z"
                fill="#FECA00"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9207 4.86656L19.7976 4.68346C20.0186 4.56244 20.2214 4.53019 20.3996 4.59766C20.4806 4.62834 20.5416 4.66329 20.7007 4.76274L20.7214 4.77572C20.8871 4.87897 20.9748 4.92103 21.0287 4.92103V5.13522C20.9052 5.13522 20.7983 5.08396 20.5866 4.95196L20.5655 4.93881C20.4224 4.8493 20.3671 4.81764 20.3078 4.79517C20.2092 4.75785 20.0824 4.778 19.9207 4.86656ZM19.5311 6.2635C19.601 6.2635 19.6577 6.21376 19.6577 6.15239C19.6577 6.09103 19.601 6.04128 19.5311 6.04128C19.4612 6.04128 19.4045 6.09103 19.4045 6.15239C19.4045 6.21376 19.4612 6.2635 19.5311 6.2635ZM19.895 6.36657C19.895 6.42794 19.8384 6.47768 19.7685 6.47768C19.6986 6.47768 19.6419 6.42794 19.6419 6.36657C19.6419 6.30521 19.6986 6.25546 19.7685 6.25546C19.8384 6.25546 19.895 6.30521 19.895 6.36657ZM20.1947 6.46943C20.2646 6.46943 20.3213 6.41968 20.3213 6.35832C20.3213 6.29695 20.2646 6.24721 20.1947 6.24721C20.1248 6.24721 20.0682 6.29695 20.0682 6.35832C20.0682 6.41968 20.1248 6.46943 20.1947 6.46943ZM20.7178 6.53614C20.7178 6.59751 20.6611 6.64726 20.5912 6.64726C20.5213 6.64726 20.4646 6.59751 20.4646 6.53614C20.4646 6.47478 20.5213 6.42503 20.5912 6.42503C20.6611 6.42503 20.7178 6.47478 20.7178 6.53614Z"
                fill="#C51918"
              />
            </g>
            <path
              d="M23.9883 8.19615L23.8798 8.41836L23.6565 8.31231L23.6565 8.31231L23.6564 8.3123L23.6564 8.31229L23.6561 8.31216L23.6548 8.31152L23.649 8.3088L23.6257 8.29791C23.6051 8.28837 23.5748 8.27442 23.5363 8.25706C23.4594 8.22234 23.3502 8.17411 23.2219 8.12038C22.9636 8.01225 22.6339 7.88452 22.3347 7.79868C22.0267 7.71031 21.7507 7.64192 21.5518 7.59566C21.4524 7.57254 21.3725 7.55499 21.3176 7.54326L21.2549 7.53009L21.239 7.52685L21.2352 7.52607L21.2343 7.5259L21.2341 7.52587L21.2341 7.52587L21.2341 7.52587L21.2341 7.52587L20.9593 7.47137L21.0446 7.20449L21.9964 4.2286L22.0351 4.10756L22.1557 4.0675L24.0213 3.44792L24.2003 3.38849L24.3066 3.54425L25.3632 5.09235L25.4452 5.21238L25.3814 5.34297L23.9883 8.19615Z"
              fill="#56C6F5"
              stroke="white"
              strokeWidth="0.5"
            />
            <mask
              id="mask5_800_124105"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="20"
              y="3"
              width="6"
              height="6"
            >
              <path
                d="M23.9883 8.19615L23.8798 8.41836L23.6565 8.31231L23.6565 8.31231L23.6564 8.3123L23.6564 8.31229L23.6561 8.31216L23.6548 8.31152L23.649 8.3088L23.6257 8.29791C23.6051 8.28837 23.5748 8.27442 23.5363 8.25706C23.4594 8.22234 23.3502 8.17411 23.2219 8.12038C22.9636 8.01225 22.6339 7.88452 22.3347 7.79868C22.0267 7.71031 21.7507 7.64192 21.5518 7.59566C21.4524 7.57254 21.3725 7.55499 21.3176 7.54326L21.2549 7.53009L21.239 7.52685L21.2352 7.52607L21.2343 7.5259L21.2341 7.52587L21.2341 7.52587L21.2341 7.52587L21.2341 7.52587L20.9593 7.47137L21.0446 7.20449L21.9964 4.2286L22.0351 4.10756L22.1557 4.0675L24.0213 3.44792L24.2003 3.38849L24.3066 3.54425L25.3632 5.09235L25.4452 5.21238L25.3814 5.34297L23.9883 8.19615Z"
                fill="white"
                stroke="white"
                strokeWidth="0.5"
              />
            </mask>
            <g mask="url(#mask5_800_124105)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.7684 5.08918L23.5976 5.25908C23.5656 5.2909 23.5086 5.2698 23.5034 5.2242L23.4784 5.00541L23.2452 4.96213C23.1961 4.95302 23.1811 4.89015 23.2218 4.86408L23.415 4.74025L23.3377 4.53134C23.3216 4.48781 23.364 4.44792 23.4078 4.46542L23.6416 4.55886L23.8125 4.38896C23.8445 4.35714 23.9015 4.37824 23.9067 4.42383L23.9316 4.64263L24.1648 4.6859C24.2139 4.69501 24.2289 4.75789 24.1883 4.78396L23.9951 4.90779L24.0724 5.1167C24.0885 5.16023 24.046 5.20012 24.0023 5.18262L23.7684 5.08918Z"
                fill="#FECA00"
              />
              <path
                d="M21.3696 6.48767L21.6086 5.65851C22.6669 5.90701 23.7702 6.22549 24.5796 6.53347L24.2109 7.32294C23.4463 7.032 22.3859 6.72629 21.3696 6.48767Z"
                fill="#E31D1C"
              />
              <path
                d="M21.6936 5.72201L21.7499 5.51395C22.7646 5.73777 23.843 6.09489 24.6267 6.42751L24.5257 6.62134C23.7571 6.29511 22.6935 5.94259 21.6936 5.72201Z"
                fill="white"
              />
              <path
                d="M21.3928 6.57657L21.4492 6.3685C22.4638 6.59232 23.4016 6.89601 24.1853 7.22864L24.0843 7.42246C23.3157 7.09623 22.3928 6.79714 21.3928 6.57657Z"
                fill="white"
              />
              <path
                d="M21.8508 6.17504L22.0681 6.08783C22.1596 6.27814 22.2725 6.32007 22.4614 6.2385C22.9075 6.04584 24.0141 6.31507 24.0141 6.67811C24.0141 6.81974 23.9217 6.9056 23.7807 6.90063C23.7011 6.89782 23.6162 6.86987 23.4916 6.81511C23.4765 6.80847 23.4665 6.80402 23.442 6.79295C23.3042 6.73048 23.2938 6.72592 23.2571 6.71418L23.3356 6.50952C23.3864 6.5258 23.3944 6.52929 23.5475 6.59867C23.5711 6.60933 23.5803 6.61346 23.5944 6.61966C23.6899 6.66164 23.7538 6.68265 23.7899 6.68392C23.7932 6.68404 23.7768 6.69934 23.7768 6.67811C23.7768 6.51838 22.8762 6.29925 22.5628 6.43457C22.2503 6.56953 21.9949 6.47472 21.8508 6.17504Z"
                fill="#272727"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124105">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Croatia;
